import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    white_button: {
      main: '#FFFFFF',
    },
    black_button: {
      main: '#000000',
    },
    primary: {
      main: '#324899',
    },
    secondary: {
      main: '#327c99',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
